import styles from "../../../../styles/races/national/MapWidget.module.scss";
import { useState, useCallback } from "react";
import ncrMapDataGeo from "./ncrmap";
import {
  ZoomableGroup,
  ComposableMap,
  Geographies,
  Geography
} from "react-simple-maps";

const MapNcr = ({ 
  city, 
  onCityClick, 
  onCityHover, 
  disabled, 
  colorFilter, 
  mapType, 
  locationData 
}) => {
  const [zoom, setZoom] = useState(1);
  const [center, setCenter] = useState([0, 0]);

  const getLocationColor = useCallback((locationSlug) => {
    const locationDataPoint = locationData.find((locationDataPoint) => locationDataPoint.locationSlug === locationSlug);
    if(mapType === "votes" && locationDataPoint?.leadingCandidateColor) {
      return locationDataPoint.leadingCandidateColor;
    } else if(mapType === "transmission-status" && locationDataPoint?.transmissionStatus?.color) {
      return locationDataPoint.transmissionStatus.color;
    }
  }, [locationData, mapType]);
    
  const projectionConfig = {
    rotate: [-7.25, 23, 10],
    scale: 70000,
    center: [118.05, 13.4],
    parallels: [10, 15]
  }
  
  const handleCityClick = ({ geo }) => event => {
    let citySlug = geo.properties.ADM3_SLUG;

    if(disabled) {
      return;
    }

    onCityClick({ 
      citySlug
    });
  };

  const isSelected = useCallback((geo) => {
    const isSelectedCity = false;

    if(city && city.slug && city.slug === geo.properties.ADM3_SLUG) {
      isSelectedCity = true;
    }

    return { isSelectedCity };
  }, [city]);

  const getStyle = useCallback((geo) => {
    const defaultColor = disabled ? "#C9D8FD" : "#C9D8FD";
    const defaultStroke = disabled ? "#FFFFFF" : "#FFFFFF";
    const style = {
      default: {
        fill: defaultColor,
        stroke: defaultStroke,
        strokeWidth: "0.5",
        outline: "none"
      },
      hover: {
        fill: "#DCDEF6",
        stroke: "transparent",
        strokeWidth: "0.5",
        outline: "none"
      },
      pressed: {
        fill: "#FFF",
        stroke: defaultColor,
        strokeWidth: "0.5",
        outline: "none"
      }
    };

    const { isSelectedCity } = isSelected(geo);
    const locationSlug = geo.properties.ADM3_SLUG || geo.properties.ADM2_SLUG;
    const locationColor = getLocationColor(locationSlug) || defaultColor;

    let locationColorFaded = "#DCDEF6";

    if(locationColor !== defaultColor) {
      const opacityValue = mapType === "votes" ? 0.5 : 0.3;
      const rgb = locationColor.slice(locationColor.indexOf("(") + 1, locationColor.lastIndexOf(",")).split(", ");
      const fadedRgb = rgb.map((value) => {
        const newValue = value * opacityValue + (255 * (1 - opacityValue));
        return newValue > 255 ? 255 : Math.floor(newValue);
      });
      locationColorFaded = `rgba(${fadedRgb.join(", ")}, 1)`;
    }
    const inFilter = locationColor === defaultColor || !!colorFilter.find(color => color === locationColor) || mapType === "transmission-status";

    // Is Selected Province
    if(!disabled && isSelectedCity) {
      if(inFilter) {
        style.default.fill = locationColor === defaultColor ? "#F5F6FF" : locationColorFaded;
        style.hover.fill = style.default.fill;
      }
    }
    
    else if(inFilter) {
      style.default.fill = locationColor;
      style.hover.fill = locationColorFaded;
    } else {
      style.hover.fill = locationColorFaded;
      style.default.fill = defaultColor;
    }

    if(isSelectedCity) {
      style.default.stroke = "#172038";
      style.default.strokeWidth = "1";
      style.hover.stroke = "#172038";
      style.hover.strokeWidth = "1";
    }

    // if(locationColor !== defaultColor) {
    //   style.hover.stroke = locationColor;
    // }

    return style;
  }, [colorFilter, disabled, getLocationColor, isSelected, mapType]);

  const handleFilter = () => {
    return false;
  };

  const handleMouseEnter = (geo) => event => {
    if(disabled) {
      return;
    }
    const locationSlug = geo.properties.ADM3_SLUG;
    const location = locationData.find(
      (locationDataPoint) => locationDataPoint.locationSlug === locationSlug
    );
    let transmissionPercentage = 0;

    if(location && location.transmissionStatus) {
      transmissionPercentage = location.transmissionStatus.percentage || 0;
    }

    onCityHover({ 
      name: `${geo.properties.ADM3_EN}`,
      location: locationSlug,
      transmissionPercentage
    });
  }

  const handleMouseLeave = () => {
    if(disabled) {
      return;
    }
    onCityHover({});
  }
  
  return (
    <div className={styles.mapContainer}>
      <ComposableMap data-tip="" projection="geoAlbers" width={450} style={{ width: "100%" }}  projectionConfig={projectionConfig}>
        <ZoomableGroup
          center={center} 
          zoom={zoom} 
          minZoom={zoom} 
          maxZoom={zoom}
          filterZoomEvent={handleFilter}
        >
          <Geographies geography={ncrMapDataGeo}>
            {({ geographies, projection, path }) => (
              <>
                { geographies.map((geo) => (
                    <Geography
                      key={geo.rsmKey}
                      geography={geo}
                      onClick={handleCityClick({ geo, projection, path })}
                      onMouseEnter={handleMouseEnter(geo)}
                      onMouseLeave={handleMouseLeave}
                      style={getStyle(geo)}
                    />
                ))}
                {
                  geographies.map((geo) => {
                    if(isSelected(geo).isSelectedCity) {
                      return <Geography                       
                        key={geo.rsmKey}
                        geography={geo}
                        onClick={handleCityClick({ geo, projection, path })}
                        onMouseEnter={handleMouseEnter(geo)}
                        onMouseLeave={handleMouseLeave}
                        style={getStyle(geo)}
                      />
                    }
                  })
                }
              </>
            )}
          </Geographies>
        </ZoomableGroup>
      </ComposableMap>
      <span>National Capital Region</span>
    </div>
  )
};

export default MapNcr;